import React from 'react';
import {
  UtilsBlock,
  Accordion,
  AccordionBody,
  AccordionItem,
  AccordionHeader,
  Text,
  TextLarge,
} from '@hz-design-system/web-ui';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { getGATrackingAttrForSSR, useGATrackingForSSR } from '../../utils/gaTracking';

const FAQ_KEYS = Array.from(Array(15));

const SellFaqList = () => {
  const { t } = useI18nContext();
  useGATrackingForSSR();

  return (
    <>
      <UtilsBlock mb={['m', 'xl', null]}>
        <UtilsBlock as="h6" textStyle={['title-4', null, 'title-2']} mb="xxs" mt="none">
          <span>{t('sell.page.faq.title')}</span>
          <span className="Title-highlight">{t('sell.page.faq.titleHighlight')}</span>
        </UtilsBlock>
        <TextLarge color="text-secondary">{t('sell.page.faq.subtitle')}</TextLarge>
      </UtilsBlock>
      <article>
        <Accordion>
          {FAQ_KEYS.map((_key, index) => (
            <AccordionItem key={`q${index}`} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
              <AccordionHeader itemProp="name" {...getGATrackingAttrForSSR('Clicked', `SellFaqItem-q${index + 1}`)}>
                <Text.Large strong>{t(`sell.page.faq.q${index + 1}.question`)}</Text.Large>
              </AccordionHeader>
              <AccordionBody
                onClick={(event) => event.stopPropagation()}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <div className="hz-Text hz-Text--bodyLarge" itemProp="text">
                  <Trans
                    i18nKey={`sell.page.faq.q${index + 1}.answer`}
                    paragraph-open={Trans.safeString('<p class="u-marginBottomXxs">')}
                    paragraph-close={Trans.safeString('</p>')}
                    list-open={Trans.safeString('<ul>')}
                    list-close={Trans.safeString('</ul>')}
                    list-item-open={Trans.safeString('<li>')}
                    list-item-close={Trans.safeString('</li>')}
                    break={Trans.safeString('<br>')}
                  />
                </div>
              </AccordionBody>
            </AccordionItem>
          ))}
        </Accordion>
      </article>
    </>
  );
};

export default SellFaqList;
